export default "__VITE_ASSET__SI0joMP4__"